import React from 'react';
import exact from 'prop-types-exact';
import { PanelGroup } from 'react-bootstrap';
import Login from './index';
import { routerProps } from '../../propTypes';

const propTypes = exact({
  ...routerProps,
});

const LoginPage = (props) => {
  return (
    <React.Fragment>
      <PanelGroup className="login-panel hidden-xs">
        <Login />
      </PanelGroup>
      <PanelGroup className="visible-xs">
        <Login />
      </PanelGroup>
    </React.Fragment>
  );
};

LoginPage.propTypes = propTypes;

export default LoginPage;
